import { logInfo } from 'utils/logging';
import { HeaderInfo } from '../Header.data';

const getHeaderData = async (): Promise<HeaderInfo | null> => {
  try {
    return await fetch('/otvety/api/header_info').then((res) => res.json());
  } catch (error: any) {
    logInfo(error.toString(), true);
    return null;
  }
};

export default getHeaderData;
